import React, { useEffect, useRef } from 'react';
import { IConfirmModalProps } from '../../../interfaces/interfaces';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';

function ConfirmModal(props: IConfirmModalProps): JSX.Element {
  const { message, onConfirm, onAbort, abortText, confirmText, info } = props;
  const modalRef = useRef<HTMLAnchorElement>(null);

  const onConfirmClick = () => {
    onConfirm();
  };

  const onAbortClick = () => {
    onAbort();
  };

  useEffect(() => {
    modalRef.current?.focus();
  }, []);

  return (
    <>
      <div className="modal confirm-modal" role="dialog">
        <div className="modal-inner">
          <h2 className="message hl-2">{message}</h2>
          {info && <p className="info tx_4">{info}</p>}
          <div className="modal-actions">
            <a
              role="button"
              className="link--button link--button-secondary ic-close"
              onClick={onAbortClick}
              onKeyDown={(e) => {
                keyboardTriggerBasic(e, onAbortClick);
              }}
              tabIndex={0}
            >
              {abortText || 'Abbrechen'}
            </a>
            <a
              role="button"
              className="link--button ic-checked"
              onClick={onConfirmClick}
              onKeyDown={(e) => {
                keyboardTriggerBasic(e, onConfirmClick);
              }}
              tabIndex={0}
              ref={modalRef}
            >
              {confirmText || 'OK'}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
export default ConfirmModal;
